import { fetchAppLaunch } from 'functions/appLaunch';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

import CommentPopup from 'components/CommentPopup';
import Footer from 'components/Footer';
import Head from 'components/Head';
import MaxWidthContainer from 'components/MaxWidthContainer';
import Menubar from 'components/Menubar';
import MobileTabBar from 'components/MobileTabBar';
import WebpBlogImg from 'components/WebpBlogImg';
import { httpCall } from 'functions/httpAction';
import _ from 'lodash';
import useSWR from 'swr';
import { swrSorraAPIFetcher } from 'utils/wpApi';
function RelatedArticle(props) {
  const { posts, itemID } = props;

  return (
    <div className="mx-[16px] my-[24px] gap-x-6 gap-y-6 px-4 lg:mx-0 lg:my-[40px] lg:grid-cols-4 lg:gap-y-0 lg:px-0">
      <MaxWidthContainer>
        <div className="w-full" id="related-article">
          <div className="text-2xl font-bold text-sorra-gray-900">相關文章</div>
          <div className="mt-[24px] flex flex-row">
            <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
              {_.filter(posts, (post) => {
                const ogImage = post.image_url?.url || '';
                return ogImage != '' > 0;
              }).map((posts, idx) => {
                const { id, title, url, category_name, image_url } = posts;
                const imageUrl = image_url?.url || '';
                const categoryName = category_name || '';

                return (
                  <a key={`${idx}:${id}`} className="block" href={url}>
                    <WebpBlogImg
                      className="aspect-square w-full rounded-xl object-cover"
                      src={imageUrl}
                    ></WebpBlogImg>
                    <div className="pt-6 text-sm text-sorra-gray-800">
                      {categoryName}
                    </div>
                    <div className="line-clamp-2 pt-1 text-lg font-medium text-sorra-gray-900">
                      {title.replaceAll('&amp;', '&')}
                    </div>
                  </a>
                );
              })}
            </div>
          </div>
        </div>
      </MaxWidthContainer>
    </div>
  );
}

export default function BrandBlogs() {
  const router = useRouter();
  const { itemID } = router.query;

  //from AppLaunch API
  const [arrNotificationState, setArrNotificationState] = useState(null);
  const [arrStoresState, setArrStoresState] = useState(null);
  const [arrProductOriginsState, setArrProductOriginsState] = useState(null);
  const [arrCategoryState, setArrCategoryState] = useState([]);
  const [arrSearchSkinProblemState, setArrSearchSkinProblemState] = useState(
    []
  );
  const [arrFactorTypesState, setArrFactorTypesState] = useState([]);
  const [arrBannerState, setArrBannerState] = useState([]);
  const [arrReviewSourcesState, setArrReviewSourcesState] = useState([]);
  const [arrIngridentSafetyState, setArrIngridentSafetyState] = useState([]);
  // const [arrIngridentsFeatureState, setArrIngridentsFeatureState] = useState([]);

  const [brandNameState, setBrandNameState] = useState('');
  const [brandIconState, setBrandIconState] = useState('');
  const [isCommentModalShow, setIsCommentModalShow] = useState(false);

  function appLaunch() {
    fetchAppLaunch().then(async ([success, error, data]) => {
      if (data.notifications) {
        setArrNotificationState(data.notifications);
      }

      if (data.stores) {
        setArrStoresState(data.stores);
      }

      if (data.product_origins) {
        setArrProductOriginsState(data.product_origins);
      }

      if (data.category_tree) {
        setArrCategoryState(data.category_tree);
      }

      if (data.search_skin_problem_keywords) {
        setArrSearchSkinProblemState(data.search_skin_problem_keywords);
      }

      if (data.factor_types) {
        setArrFactorTypesState(data.factor_types);
      }

      if (data.review_sources) {
        setArrReviewSourcesState(data.review_sources);
      }

      if (data.ingredient_safeties) {
        setArrIngridentSafetyState(data.ingredient_safeties);
      }

      // if (data.ingredient_features) {
      //   setArrIngridentsFeatureState(data.ingredient_features);
      // }

      fetchBlogContent();
    });
  }

  async function fetchBlogContent() {
    try {
      const [success, error, statusCode, data] = await httpCall(
        'get',
        process.env.NEXT_PUBLIC_API_HOST +
          '/api/v2/brand/' +
          router.query.itemID +
          '/overview',
        null,
        null
      );

      if (success == true) {
        console.log({ data });

        if (data.brand.name) {
          setBrandNameState(data.brand.name);
        }

        if (data.brand.image.url) {
          setBrandIconState(data.brand.image.url);
        }
      }
    } catch (error) {
      console.log('error', error);
    }
  }

  const { data: posts, isLoading: isPostsLoading } = useSWR(
    brandNameState != ''
      ? '/v1/wordpress/posts?page=1&per_page=4&search=' + brandNameState
      : null,
    swrSorraAPIFetcher,
    { fallbackData: [] }
  );

  useEffect(() => {
    if (router.query.itemID) {
      appLaunch();
    }
  }, [router.query]);

  return (
    <div>
      <Head />

      <main>
        <Menubar
          props={{
            homeExtend: false,
            notifications: arrNotificationState,
            sourceUI: 'ProductDetailReviews',
          }}
        />

        <div
          className={
            'globals-centerContentsMargin' +
            (arrNotificationState?.length > 0 ? ' withNoti' : '')
          }
          style={{ marginBottom: 0 + 'px' }}
        >
          <div className="">
            <MaxWidthContainer className="flex p-4">
              <img src="/svgs/chevron-left.svg"></img>
              <a
                href={'/brand/' + itemID}
                className="pl-[8px] font-medium text-sorra-gray-900"
              >
                返回
              </a>
            </MaxWidthContainer>
          </div>
        </div>

        <div className="mb-[24px] mt-[12px] lg:mb-[40px] lg:mt-[40px]">
          <MaxWidthContainer className="flex items-center px-4">
            <div className="w-[80px] lg:w-[112px]">
              <div className="h-[80px] w-[80px] rounded-lg bg-[#F5F5F5] p-[4px] lg:h-[112px] lg:w-[112px] lg:p-[12px]">
                <img src={brandIconState}></img>
              </div>
            </div>
            <div className="grow pl-[16px] lg:pl-[24px]">
              <div className="text-lg font-medium text-sorra-gray-900 lg:text-2xl">
                {brandNameState}
              </div>
            </div>
          </MaxWidthContainer>
        </div>

        <div className="h-[1px] w-full bg-[#E7E7E7]" />

        <RelatedArticle posts={posts} itemID={router.query.itemID} />
      </main>

      <CommentPopup
        externalPopupShown={isCommentModalShow}
        externalProductID={null}
        externalProductBrandName={null}
        externalProductName={null}
        setExternalPopupShown={setIsCommentModalShow}
      />

      <Footer />

      <MobileTabBar props={{ highlighted: 'home' }} />
    </div>
  );
}
